import axios from "axios";

export const state = {
    labpatients: [],
};

export const getters = {
    labpatients: state => state.labpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.labpatients = newValue
    },
};

export const actions = {
    fetchLabPatients({ commit }) {
        axios.get('/labpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
};
